import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'parcelsDialog.title',
    defaultMessage: 'Select parcel',
    description: 'Title of the select parcel dialog',
  },
  numberOfItems: {
    id: 'parcelsDialog.numberOfItems',
    defaultMessage: 'Number of items: {count}',
    description: 'Number of items text of the select parcel dialog',
  },
  buttons: {
    close: {
      id: 'parcelsDialog.buttons.close',
      defaultMessage: 'Close',
      description: 'Label of the close button in the select parcel dialog',
    },
    createParcel: {
      id: 'parcelsDialog.buttons.createParcel',
      defaultMessage: 'Create parcel',
      description: 'Label of the create parcel button in the select parcel dialog',
    },
  },
};

export default defineMessages(translations);
